/**
 * Les sous-onglets de « Vue d'ensemble » dans la fiche d'un enfant.
 *
 * Hedi, le 27 septembre 2026 : *« je veux que "Compétences et exercices", "Le
 * travail fourni" et "Résumés de séance" soient des sous-tabs de "Vue
 * d'ensemble" »*, le premier sous-onglet s'appelant « Synthèse » — l'écran qui
 * portait jusqu'ici le nom de l'onglet.
 *
 * **Les adresses ne bougent pas** (`cahier`, `effort`, `resumes`, sous la fiche
 * de l'enfant) : la route qui monte ce layout est **sans chemin**, elle ne fait
 * que regrouper. Le tableau de bord, la fiche et `ui/planDuSoir` mènent déjà à
 * ces adresses, et les déplacer sous un segment de plus aurait demandé une
 * redirection par écran pour ne rien apporter au parent. C'est pour la même
 * raison que l'onglet « Vue d'ensemble » s'allume par `aussi` et non par le
 * préfixe de son adresse.
 *
 * Comme `ChildLayout`, c'est un layout avec un `<Outlet/>` : suivre un
 * sous-onglet laisse la rangée à l'écran.
 */

import { Outlet, useParams } from "react-router-dom";

import { SousOnglets } from "@/ui/SousOnglets";

/** Les segments regroupés sous « Vue d'ensemble », la synthèse (l'index) mise
 *  à part. `ChildLayout` les lit pour allumer l'onglet : une seule liste, sans
 *  quoi un quatrième sous-onglet ajouté ici laisserait l'onglet éteint. */
export const SOUS_LA_VUE_D_ENSEMBLE = [
  { segment: "cahier", label: "Compétences et exercices" },
  { segment: "effort", label: "Le travail fourni" },
  { segment: "resumes", label: "Résumés de séance" },
] as const;

export function VueDEnsembleLayout() {
  const { childId = "" } = useParams();
  const base = `/parents/enfant/${childId}`;

  const tabs = [
    { to: base, label: "Synthèse", end: true },
    ...SOUS_LA_VUE_D_ENSEMBLE.map(({ segment, label }) => ({ to: `${base}/${segment}`, label })),
  ];

  return (
    <>
      <SousOnglets tabs={tabs} label="Vue d'ensemble" />
      <Outlet />
    </>
  );
}
